if (!customElements.get('pino-sticky-info')) {
  customElements.define('pino-sticky-info', class extends HTMLElement {
    connectedCallback() {
      this.lastY = window.scrollY;
      this.offset = null;
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          const delta = window.scrollY - this.lastY;
          this.lastY = window.scrollY;
          if (!window.matchMedia('(min-width: 640px)').matches || !this.classList.contains('product__column-sticky')) {
            this.style.removeProperty('--pino-sticky-top');
            this.offset = null;
            return;
          }
          const header = document.querySelector('.section-header');
          const maximum = Math.max(16, header ? header.getBoundingClientRect().bottom + 16 : 16);
          const minimum = Math.min(maximum, window.innerHeight - this.offsetHeight - 24);
          this.offset = Math.max(minimum, Math.min(maximum, (this.offset ?? maximum) - delta));
          this.style.setProperty('--pino-sticky-top', this.offset + 'px');
        });
      };
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this);
      const header = document.querySelector('.section-header');
      if (header) this.resize.observe(header);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
